export default __webpack_public_path__ + "static/media/notting_1.9aa984d9.jpg";